import { ActionEnum } from '../../common'
import {
  CommonAction,
  CommonState,
  SET_ACTION,
  SET_ACTION_PROCESSING,
  SET_ALERT_MESSAGE,
  SET_SHOW_MANAGE_MODAL,
  SET_SHOW_RESET_PASSWORD_MODAL,
  SET_SHOW_SEARCH_DRAWER,
} from '../types'

const initialState: CommonState = {
  management: {
    action: ActionEnum.VIEW,
    actionProcessing: false,
    showManageModal: false,
    showSearchDrawer: false,
    showResetPasswordModal: false,
    alertMessage: undefined,
  },
  regex: {
    phone: new RegExp(/^0\d{9}$/),
    identityCardNumber: new RegExp(/^([0-9]{9,10}|[0-9]{12,13})$/),
  },
}

export const commonReducer = (
  state = initialState,
  action: CommonAction
): CommonState => {
  switch (action.type) {
    case SET_ACTION:
      return {
        ...state,
        management: {
          ...state.management,
          action: action.payload,
        },
      }
    case SET_ACTION_PROCESSING:
      return {
        ...state,
        management: {
          ...state.management,
          actionProcessing: action.payload,
        },
      }
    case SET_SHOW_MANAGE_MODAL:
      return {
        ...state,
        management: {
          ...state.management,
          showManageModal: action.payload,
        },
      }
    case SET_SHOW_RESET_PASSWORD_MODAL:
      return {
        ...state,
        management: {
          ...state.management,
          showResetPasswordModal: action.payload,
        },
      }
    case SET_SHOW_SEARCH_DRAWER:
      return {
        ...state,
        management: {
          ...state.management,
          showSearchDrawer: action.payload,
        },
      }
    case SET_ALERT_MESSAGE:
      return {
        ...state,
        management: {
          ...state.management,
          alertMessage: action.payload,
        },
      }
    default:
      return state
  }
}
